export * from './tc-dialog-content/tc-dialog-content.component';
export * from './tc-dialog-header/tc-dialog-header.component';
export * from './tc-dialog-footer/tc-dialog-footer.component';
export * from './tc-prompt-dialog/tc-prompt-dialog.component';
export * from './tc-help-dialog/tc-help-dialog.component';
